import { useMemo } from 'react'

import { useSelector } from 'react-redux'
import { Button, Dropdown, Menu, Select, Switch } from 'antd'
import { faGear } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import OverlaySettingsDropdown from '../../Quotas/SchoolQuotasView/OverlaySettingsDropdown'
import IconButton from '../../../../Components/antd/Buttons/IconButton'
import { TIME_PERIODS } from '../../../../utils/timePeriods'
import { InternshipsSettings } from '../../../../Components/antd/Tables/DragTable/OverlaySettings'

const Option = Select.Option

const PlacesOccupancyTablesSettings = ({
  overlayPrefix, visible, overlayMenuVisible, period, overlaySettings = new InternshipsSettings(), isYearly, isHostpitalDepartmentViewToggled,
  onClick, onPeriodChange, onVisibleChange, onOverlayMenuVisibleChange, onOverlaySettingsSelection, onResetGravity, onIsYealyChange,
  onHospitalDepartmentViewToggled
}) => {
  const t = useSelector(selectTranslate)

  const periods = useMemo(() => TIME_PERIODS.map((option, index) => (
    <Option key={index} value={option.quantity}>
      {t(option.text)}
    </Option>
  )), [t])

  return (
    <Dropdown
      trigger={['click']}
      visible={visible}
      onVisibleChange={onVisibleChange}
      onClick={onClick}
      overlay={(
        <Menu>
          <Menu.ItemGroup title={t('common.period')}>
            <Menu.Item>
              <Select
                className='w-100 j-ctn-s mt-4'
                value={period.quantity}
                onChange={onPeriodChange}
              >
                {periods}
              </Select>
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup title={t('common.overlay')}>
            <Menu.Item>
              <OverlaySettingsDropdown
                className='w-100 j-ctn-s mt-4'
                prefix={overlayPrefix}
                visible={overlayMenuVisible}
                onVisibleChange={onOverlayMenuVisibleChange}
                onClick={onOverlayMenuVisibleChange}
                settings={overlaySettings}
                onSelection={onOverlaySettingsSelection}
              />
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup title={t('places_occupancy_table_settings.sort_by_hospital_department')}>
            <Menu.Item>
              <Switch checked={isHostpitalDepartmentViewToggled} onChange={onHospitalDepartmentViewToggled} />
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup title={t('common.reset_gravity')}>
            <Menu.Item>
              <Button onClick={onResetGravity}> {t('common.reset')} </Button>
            </Menu.Item>
          </Menu.ItemGroup>
        </Menu>
      )}
    >
      <IconButton
        icon={faGear}
        type={isYearly ? 'primary' : 'default'}
        text={t('school_quota_view.dropdowns.configure_table')}
      />
    </Dropdown>
  )
}

export default PlacesOccupancyTablesSettings
